import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { DebtBuyerPayload, DebtBuyerResponse } from 'shared/types/customObject/CustomObject';
import { getSelectedDivision } from '@/helpers/utils/siteUtils';
import {
  GetExcludedBrandsDataAction,
  GetDebtBuyerDataAction,
  GetDebtBuyerDataByCodeAction,
} from '../../types/actions/CustomObjectActions';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';

export type CustomObjectActions = {
  getExcludedBrandsData: GetExcludedBrandsDataAction;
  getDebtBuyerData: GetDebtBuyerDataAction;
  getDebtBuyerDataByCode: GetDebtBuyerDataByCodeAction;
};

export const getCustomObjectActions = (sdk: SDK<ComposableCommerceEvents>) => {
  return {
    getExcludedBrandsData: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.callAction<any>({
        actionName: 'customObjects/workerGetExcludedBrandsData',
        serverOptions: options.serverOptions,
        query: { divisionCode: getSelectedDivision() ?? 'zb' },
      });

      return response;
    },

    getDebtBuyerData: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.callAction<any>({
        actionName: 'customObjects/workerGetDebtBuyerData',
        serverOptions: options.serverOptions,
      });
      return response;
    },
    getDebtBuyerDataByCode: async (payload: DebtBuyerPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.callAction<DebtBuyerResponse>({
        actionName: 'customObjects/getDebtBuyerDataByCode',
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
  };
};
